import type { ListMilestonesOptions, MilestoneListResponse } from "@shopify-harness/sdk";
import { queryOptions } from "@tanstack/react-query";

import { monthRange } from "./month";

/** 1ヶ月分の取得上限。API の最大値。超過分は truncated として画面に明示する */
const MILESTONES_MONTH_LIMIT = 100;

export interface MilestonesApi {
  list: (options?: ListMilestonesOptions) => Promise<MilestoneListResponse>;
}

export const milestoneQueryKeys = {
  all: ["milestones"] as const,
  month: (month: string) => [...milestoneQueryKeys.all, "month", month] as const
};

/** 月単位で取得する。種別の絞り込みは取得済みデータに対して画面側で行う。 */
export function milestonesQueryOptions(api: MilestonesApi, month: string) {
  const { from, to } = monthRange(month);
  return queryOptions({
    queryKey: milestoneQueryKeys.month(month),
    queryFn: ({ signal }) => api.list({ from, to, limit: MILESTONES_MONTH_LIMIT, signal }),
    staleTime: 30_000
  });
}
